import axios from 'axios'
export default {
    state: {
        ref_statuses: {
            1: {id: 0, name: 'создана'},
            2: {id: 1, name: 'зарегистрирована'},
            3: {id: 2, name: 'допущена к отбору'},
            4: {id: 3, name: 'победитель конкурсного отбора'},
            5: {id: 4, name: 'архив'},
            6: {id: 5, name: 'удалена'},
            7: {id: 6, name: 'отклонена'},
        }   
    },
    getters: {
        ref_statuses: (state) => state.ref_statuses
    },
    mutations: {},
    actions: {}
}